module.exports = __webpack_public_path__ + "img/lab-primary.bcad3ab6.svg";